<div class="pt-3">
  <div class="row">
    <div class="col fw-bold">Asset ID</div>
  </div>
  <div class="row">
    <div class="col ">{{ id() || '?' }}</div>
  </div>
  <div class="row">
    <div class="col fw-bold">Related device ID's</div>
  </div>
  <div class="row">
    @for (deviceAssociation of relatedDeviceAssociations(); track deviceAssociation.id) {
      <div class="col"> - {{ deviceAssociation.deviceId || '?' }}</div>
    }
  </div>
</div>
